module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"commentTip":"Ваш комментарий (Enter — отправить)","bindToTimestamp":"Привязать к временной метке","bindToAnswer":"Привязать к ответу на вопрос","send":"Отправить"}}')
  delete Component.options._Ctor
}
